export const footerTranslations = {
  FOOTER_PRIVACY_STATEMENT: 'Privacyverklaring',
  FOOTER_TERMS_AND_CONDITIONS: 'Algemene Voorwaarden',

  FOOTER_NAVIGATION_TITLE: 'Direct naar...'
};
